import RecentPostsBlock from "./RecentPostsBlock";

export default RecentPostsBlock;
